var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCalendarActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 10C2.5 6.54822 5.29822 3.75 8.75 3.75H21.25C24.7018 3.75 27.5 6.54822 27.5 10V15C27.5 15.6904 26.9404 16.25 26.25 16.25C25.5596 16.25 25 15.6904 25 15V10C25 7.92893 23.3211 6.25 21.25 6.25H8.75C6.67893 6.25 5 7.92893 5 10V21.25C5 23.3211 6.67893 25 8.75 25H15C15.6904 25 16.25 25.5596 16.25 26.25C16.25 26.9404 15.6904 27.5 15 27.5H8.75C5.29822 27.5 2.5 24.7018 2.5 21.25V10Z",
    fill: "url(#paint0_linear_0_337)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2.5C10.6904 2.5 11.25 3.05964 11.25 3.75V7.5C11.25 8.19036 10.6904 8.75 10 8.75C9.30964 8.75 8.75 8.19036 8.75 7.5V3.75C8.75 3.05964 9.30964 2.5 10 2.5Z",
    fill: "url(#paint1_linear_0_337)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 12.5C7.5 11.8096 8.05964 11.25 8.75 11.25H21.25C21.9404 11.25 22.5 11.8096 22.5 12.5C22.5 13.1904 21.9404 13.75 21.25 13.75H8.75C8.05964 13.75 7.5 13.1904 7.5 12.5Z",
    fill: "url(#paint2_linear_0_337)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 2.5C20.6904 2.5 21.25 3.05964 21.25 3.75V7.5C21.25 8.19036 20.6904 8.75 20 8.75C19.3096 8.75 18.75 8.19036 18.75 7.5V3.75C18.75 3.05964 19.3096 2.5 20 2.5Z",
    fill: "url(#paint3_linear_0_337)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 20C21.1193 20 20 21.1193 20 22.5C20 23.8807 21.1193 25 22.5 25C23.8807 25 25 23.8807 25 22.5C25 21.1193 23.8807 20 22.5 20ZM17.5 22.5C17.5 19.7386 19.7386 17.5 22.5 17.5C25.2614 17.5 27.5 19.7386 27.5 22.5C27.5 25.2614 25.2614 27.5 22.5 27.5C19.7386 27.5 17.5 25.2614 17.5 22.5Z",
    fill: "url(#paint4_linear_0_337)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_337",
    x1: 2.92049,
    y1: 3.74999,
    x2: 28.0345,
    y2: 4.32935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01A0AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076B9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_337",
    x1: 8.79205,
    y1: 2.5,
    x2: 11.3046,
    y2: 2.52202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01A0AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076B9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_337",
    x1: 21.1417,
    y1: 13.75,
    x2: 11.6094,
    y2: 7.50604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0BA47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677095,
    stopColor: "#F3D25C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0_337",
    x1: 18.792,
    y1: 2.5,
    x2: 21.3046,
    y2: 2.52202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01A0AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076B9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_0_337",
    x1: 26.5945,
    y1: 27.5,
    x2: 17.6199,
    y2: 26.5202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0BA47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677095,
    stopColor: "#F3D25C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendarActive);
export default __webpack_public_path__ + "static/media/icon_calendar_active.c5ad0f0feeecc5cdf3d604549e7dbf66.svg";
export { ForwardRef as ReactComponent };